<template>
<div>
    <b-modal id="createLawLedesFormModal" centered size="xl" no-close-on-backdrop ref="createLawLedesFormModal" :title="$t('createLawLedes.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-col class="col-lg-12">
                <label for="create-ledes-ledes-input">{{ $t('createLawLedes.ledes') }}</label>
                <validation-provider #default="{ errors }" :name=" $t('createLawLedes.ledes')" rules="required">
                    <b-form-textarea id="create-ledes-ledes-input" class="no-wrap-textarea" size="sm" rows="20" :state="errors.length > 0 ? false:null" v-model="fileContains" />
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </b-col>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getInvoiceList: {
            type: Function
        }
    },
    data() {
        return {
            invoiceId: 0,
            clientAccountingId: 0,
            lawClientAccountingLedesId: 0,
            base64: '',
            encodedLedes: '',
            employeeId: null,
            fileContains: '',
            fileName: '',
            type: '',
            ledesTypeId: 0
        }
    },
    methods: {
        showInfo(invoiceId, clientAccountingId, ledesTypeId, lawInvoiceDetailList) {
            this.invoiceId = invoiceId
            this.clientAccountingId = clientAccountingId
            this.ledesTypeId = ledesTypeId
            this.$refs['createLawLedesFormModal'].show()
            const data = {
                lawInvoiceId: this.invoiceId,
                employeeId: localStorage.getItem('EmployeeId'),
                lawInvoiceDetailList : lawInvoiceDetailList
            }
            const controller = {
                name: 'LawInvoice',
                actionName: 'CreateLawInvoiceCsvFile'
            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.fileName = response.data.fileName
                    this.type = response.data.fileExtension
                    this.fileContains = response.data.fileContains
                } else {
                    this.$bvModal.hide('createLawLedesFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
         downloadLedes() {
             let data = {
                 id: this.lawClientAccountingLedesId
             }
             let controller = {
                 name: 'LawClientAccountingLedes',
                 actionName: 'DownloadLawClientAccountingLedesFile'
             }
             let payload = {
                 data: data,
                 controller: controller
             }
             this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                 if (response.data.resultStatus == true) {
                     const parts = response.data.fileName.split('.');
                     const name = parts[0];
                     const type = parts[1];
                     this.$downloadFile(name, response.data.fileAsBase64, type)

        //             if (this.ledesTypeId == 7) {
        //                 data = {
        //                     InvoiceId: this.invoiceId,
        //                 }
        //                 controller = {
        //                     name: 'Invoice',
        //                     actionName: 'CreateInvoiceXmlFileForLedes'
        //                 }
        //                 payload = {
        //                     data: data,
        //                     controller: controller
        //                 }

        //                 this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
        //                     if (response.data.resultStatus == true) {
        //                         this.$downloadFile(name, response.data.base64File, ".xml")
        //                     } else {
        //                         this.$WarningAlert(response.data.resultMessage)
        //                     }

        //                 })

        //                 data = {
        //                     InvoiceId: this.invoiceId,
        //                 }
        //                 controller = {
        //                     name: 'Invoice',
        //                     actionName: 'CreateInvoiceExcelFileForLedes'
        //                 }
        //                 payload = {
        //                     data: data,
        //                     controller: controller
        //                 }

        //                 this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
        //                     if (response.data.resultStatus == true) {
        //                         this.$downloadFile(name, response.data.fileAsBase64, ".xlsx")
        //                     } else {
        //                         this.$WarningAlert(response.data.resultMessage)
        //                     }
        //                 })
        //             }
        //         } else {
        //             this.$WarningAlert(response.data.resultMessage)
                 }
             })
        },
        addOrUpdate() {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    try {
                        this.encodedLedes = btoa(unescape(encodeURIComponent(this.fileContains)));
                    } catch (e) {
                        console.error('Base64 encode hatası:', e);
                    }
                    const data = {
                        base64: this.encodedLedes,
                        lawInvoiceId: this.invoiceId,
                        lawClientAccountingId: this.clientAccountingId,
                        employeeId: localStorage.getItem('EmployeeId'),
                        name: this.fileName,
                        type: this.type
                    }
                    const controller = {
                        name: 'LawClientAccountingLedes',
                        actionName: 'SaveLawClientAccountingLedes'
                    }
                    const payload = {
                        data: data,
                        controller: controller
                    }
                    this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('createLawLedesFormModal')
                            this.lawClientAccountingLedesId = response.data.lawClientAccountingLedesId
                            this.downloadLedes()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
    }
}
</script>

<style scoped>
.tab-content>.active {
    display: block;
    width: 75em;
}

.no-wrap-textarea {
    white-space: nowrap !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    resize: none !important;
}
</style>
